import { httpClient } from "../http/httpClient";

export interface GetPublicTransactionResponse {
  status: string;
  url: string;
  _id: string;
}

export interface GetPublicTransactionParams {
  customerCpf?: string;
  sellerId?: string;
  id?: string;
}

export async function getPublicTransactionPan(
  params: GetPublicTransactionParams,
) {
  const { data } = await httpClient
    .get<GetPublicTransactionResponse>(`/self-hire/transaction`, { params })
    .catch((err) => {
      throw err?.response?.data || err;
    });

  return data;
}
